export default function(option, Dayjs, dayjs) {
  dayjs.strict = function(date) {
    const cfg = { date: dayjs(date, [ 'YYYY-MM-DDTHH:mm:ss[Z]', 'YYYY-MM-DD' ], true), args: arguments }; // eslint-disable-line prefer-rest-params
    return new Dayjs(cfg);
  };
}
